var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Button } from 'ui/styled';
import { GREEN_DARK, RED, WHITE } from 'ui/constants';
import { useNicService } from 'stores/nic/useNicService';
import { BellWrapper } from '../IncomingCall/styled';
import { ButtonsContainer, ChatIcon, ChatWrapper, IncomingHeader, SkillName } from './styled';
var IncomingChat = function (_a) {
    var contactId = _a.contactId, skillName = _a.skillName;
    var _b = useState(false), isAccepting = _b[0], setIsAccepting = _b[1];
    var _c = useState(false), isRejecting = _c[0], setIsRejecting = _c[1];
    var _d = useNicService(), acceptChat = _d.acceptChat, rejectChat = _d.rejectChat;
    var handleAccept = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsAccepting(true);
                    return [4 /*yield*/, acceptChat(contactId)];
                case 1:
                    _a.sent();
                    setIsAccepting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleReject = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsRejecting(true);
                    return [4 /*yield*/, rejectChat(contactId)];
                case 1:
                    _a.sent();
                    setIsRejecting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(ChatWrapper, { "data-test": "nicIncomingChat", children: [_jsxs(IncomingHeader, { children: [_jsx(BellWrapper, { children: _jsx(ChatIcon, {}) }), _jsxs("div", { children: [_jsx(SkillName, { children: "Incoming chat" }), skillName && _jsxs("div", { children: ["Skill: ", skillName] })] })] }), _jsxs(ButtonsContainer, { children: [_jsxs(Button, { btntype: "custom", btnsize: "custom", bgcolor: RED, color: WHITE, border: "none", padding: "12px 24px", loading: isRejecting, disabled: isAccepting, onClick: handleReject, children: [_jsx(CloseOutlined, {}), "Reject"] }), _jsxs(Button, { btntype: "custom", btnsize: "custom", bgcolor: GREEN_DARK, color: WHITE, border: "none", padding: "12px 24px", loading: isAccepting, disabled: isRejecting, onClick: handleAccept, children: [_jsx(CheckOutlined, {}), "Accept"] })] })] }));
};
export default IncomingChat;
